import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MessageService } from "primeng/api";
import { ToastModule } from "primeng/toast";

@Component({
  selector: "app-toast-message",
  standalone: true,
  imports: [CommonModule, ToastModule],
  templateUrl: "./toast-message.component.html",
  styleUrl: "./toast-message.component.scss",
})
export class ToastMessageComponent {
  @Input() toastKey = "global"; // Optional: Use a specific key for this toast instance

  constructor(private readonly messageService: MessageService) {}

  /**
   * Shows a success toast message.
   * @param title The title of the toast.
   * @param message The main message content.
   * @param life Duration in milliseconds to show the toast (default: 3000).
   */
  showSuccess(title: string, message: string, life = 3000): void {
    this.messageService.add({
      key: this.toastKey,
      severity: "success",
      summary: title,
      detail: message,
      life: life,
    });
  }

  /**
   * Shows an info toast message.
   * @param title The title of the toast.
   * @param message The main message content.
   * @param life Duration in milliseconds to show the toast (default: 3000).
   */
  showInfo(title: string, message: string, life = 3000): void {
    this.messageService.add({
      key: this.toastKey,
      severity: "info",
      summary: title,
      detail: message,
      life: life,
    });
  }

  /**
   * Shows a warning toast message.
   * @param title The title of the toast.
   * @param message The main message content.
   * @param life Duration in milliseconds to show the toast (default: 3000).
   */
  showWarn(title: string, message: string, life = 3000): void {
    this.messageService.add({
      key: this.toastKey,
      severity: "warn",
      summary: title,
      detail: message,
      life: life,
    });
  }

  /**
   * Shows an error toast message.
   * @param title The title of the toast.
   * @param message The main message content.
   * @param life Duration in milliseconds to show the toast (default: 3000).
   */
  showError(title: string, message: string, life = 3000): void {
    this.messageService.add({
      key: this.toastKey,
      severity: "error",
      summary: title,
      detail: message,
      life: life,
    });
  }

  /**
   * Clears all messages from the toast.
   */
  clear(): void {
    this.messageService.clear(this.toastKey);
  }
}
